import { useCallback, useState } from 'react';
import { useAppApi } from '../../app/ApiProvider';
import { useAsync } from '../../hooks/useAsync';
import { useI18n } from '../../i18n/I18nProvider';
import { copyText, download, shareLink } from '../../telegram/telegram';
import { SmallButton } from '../../ui/Cta';
import { ErrorState, Loader } from '../../ui/feedback';
import { SectionTitle } from '../../ui/Screen';
import { Card, Hint } from './profile/fields';

/** Ссылка и QR-карточка заведения: как бизнес зовёт клиентов. */
export function ShareBlock(props: { slug: string; name: string }): JSX.Element {
  const { t } = useI18n();
  const api = useAppApi();
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const { state, reload } = useAsync(
    useCallback(() => api.client.getBusinessLink(props.slug), [api, props.slug]),
    [props.slug],
  );
  const qrUrl = `${location.origin}/api/businesses/${encodeURIComponent(props.slug)}/qr.svg`;

  const act = (fn: () => Promise<void> | void) => async () => {
    setError(null);
    try {
      await fn();
    } catch (e) {
      setError(e);
    }
  };

  return (
    <div className="px-4 pt-6">
      <SectionTitle>{t('shareTitle')}</SectionTitle>
      <Card>
        {state.status === 'loading' ? <Loader /> : null}
        {state.status === 'failed' ? <ErrorState error={state.error} onRetry={reload} withTitle={false} /> : null}
        {state.status === 'ready' ? (
          <div className="py-3">
            <img src={qrUrl} alt={state.data.link} className="mx-auto w-full max-w-[240px] rounded-[12px]" />
            <div className="mt-3 select-all break-all text-center text-[13px] font-semibold">{state.data.link}</div>
            <div className="mt-3 flex gap-2">
              <SmallButton
                onClick={act(async () => {
                  await copyText(state.data.link);
                  setCopied(true);
                })}
              >
                {copied ? t('shareCopied') : t('shareCopy')}
              </SmallButton>
              <SmallButton
                variant="accent"
                onClick={act(() => shareLink(state.data.link, `${props.name} — ${t('shareText')}`))}
              >
                {t('shareSend')}
              </SmallButton>
            </div>
            <div className="mt-2 flex">
              <SmallButton onClick={act(() => download(qrUrl, `${props.slug}-qr.svg`))}>
                {t('shareDownload')}
              </SmallButton>
            </div>
            {error !== null ? <ErrorState error={error} withTitle={false} /> : null}
          </div>
        ) : null}
      </Card>
      <Hint>{t('shareHint')}</Hint>
    </div>
  );
}
